// export const BACKEND_URL = (
//   process.env.REACT_APP_BACKEND_URL ||
//   "http://localhost/Project/OnlineDesignCourse/backend"
// ).replace(/\/+$/, "");

export const BACKEND_URL = (
  process.env.REACT_APP_BACKEND_URL || "https://designwala.online/backend"
).replace(/\/+$/, "");
